import React from 'react';
import './Support.css';
import { HelpCircle, Download, MessageCircleQuestion, MessageCircle, BadgeQuestionMark, CircleQuestionMark } from 'lucide-react';

const Support = () => {
  const supportItems = [
    {
      id: 1,
      title: 'الحصول على المساعدة',
      description: 'الخدمة والدعم بعد فترة الخدمة العادية، مهما حدث، نحن نجعل ذلك ممكناً',
      icon: <MessageCircle size={48} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/support#get-help'
    },
    {
      id: 2,
      title: 'التنزيلات',
      description: 'دائماً ما نحسن ونبتكر في منتجاتنا وخدماتنا',
      icon: <Download size={48} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/support#downloads'
    },
    {
      id: 3,
      title: 'الأسئلة الشائعة',
      description: 'منتجات وخدمات متميزة، رضا وتجربة ملكية استثنائية',
      icon: <CircleQuestionMark size={48} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/support#faq'
    }
  ];

  return (
    <section id="support" className="section support">
      <div className="container">
        <h2 className="section-title">الدعم</h2>
        <div className="support-grid">
          {supportItems.map((item) => (
            <a 
              key={item.id} 
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="support-item"
            >
              <div className="support-icon">
                {item.icon}
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <div className="wave-underline"></div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Support;
